import { render } from "./ContactForm.vue?vue&type=template&id=b2953530"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=b2953530&lang=css"

import exportComponent from "/home/michael/Public/sites/mlibs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__